<template>
<div>
    <SimpleForm api="imageanalyzer" title="Image Analyzer" id="image-analyzer" :fields="fields" @loaded="onLoaded" ref="ftform"/>
    <otif-table :xactions="actions" :columns="file_type_columns" :paginated="true" :rows="ft_rows" title="Supported Image Extensions" @change="updateSupportedImages"/>
    <otif-modal v-model="supportedImages" title="Edit Supported Image extensions">
        <!--otif-textInput v-model="editFileTypeMediaType" label="Mime Type"/-->
        <otif-textInput v-model="editSupportedImageExtensionType" label="Supported Image Extension Type"/>
    </otif-modal>
</div>
</template>

<script>

import SimpleForm from '../../../components/forms/SimpleForm.vue';


const formFields = [
    ['enabled', {component: 'otif-switch'}],
    'imageAnalyzerScheme',
    'imageAnalyzerHost',
    'imageAnalyzerPort',
    'imageAnalyzerBasePath',
    'imageAnalyzerResource',
    'imageAnalyzerThreshold',
    'imageAnalyzerClientSocketTimeout',
    'imageAnalyzerClientConnectionTimeout'
];


export default {
    data() {
        return {
            supportedImages: false,
            editFileTypeRow: null,
            editSupportedImageExtensionType: '',
            fields: formFields,
            file_type_columns: [{
                name: 'extension',
                label: 'Image Extension Type',
                invalidMessage: 'Value must be an image extension type'
            }],
            actions: [{
                name: 'edit',
                label: 'Edit',
                callback: (rowNumber) => {
                    this.supportedImages = true
                    this.editFileTypeRow = rowNumber;
                    this.editSupportedImageExtensionType = this.ft_rows[rowNumber][0];
                }
            },{
                name: 'delete',
                label: 'Delete',
                callback: () => {
                    console.log('delete!');
                }
            }],
            ft_rows: []
        }
    },    

    methods: {
        onLoaded(data) {
            this.ft_rows = data.supportedImages.value.map((ft) => {
                return [ft.extension];
            });
        },

        updateSupportedImages($e) {
            const rows = $e.rows;

            this.$refs['ftform'].setValue('supportedImages', rows.map((row) => {
                return {
                    extension: row[0]
                }
            }));
        }
    },    
    components: {
        SimpleForm
    }

}

</script>
